import type { IconSvgProps } from '../iconProps';

const ImageIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="2.5"
      y="5.25"
      width="19"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#159FAA"
    />
    <path
      d="M5 8.81261C5 9.951 5.85564 10.8748 6.90964 10.8748C7.96337 10.8748 8.81803 9.951 8.81803 8.81261C8.81803 7.67423 7.96323 6.75 6.90964 6.75C5.85564 6.75 5 7.67423 5 8.81261Z"
      fill="#159FAA"
    />
    <path
      d="M5 17.75H19V12.9378L14.8636 8.46915L9.77278 13.9684L8.18204 12.2503L5 15.6871V17.75Z"
      fill="#159FAA"
    />
    <path
      d="M11.278 16.75V13.8H11.706V16.75H11.278ZM14.3344 13.8H15.0764V16.75H14.6644V14.104L14.6764 14.108L13.9824 16.75H13.3864L12.6864 14.106L12.6984 14.1V16.75H12.2844V13.8H13.0264L13.6884 16.47H13.6684L14.3344 13.8ZM16.7829 16.792C16.5576 16.792 16.3529 16.7327 16.1689 16.614C15.9862 16.4953 15.8402 16.3233 15.7309 16.098C15.6229 15.8727 15.5689 15.6 15.5689 15.28C15.5689 14.9587 15.6242 14.6853 15.7349 14.46C15.8469 14.2347 15.9976 14.062 16.1869 13.942C16.3776 13.822 16.5909 13.762 16.8269 13.762C17.0202 13.762 17.1836 13.7947 17.3169 13.86C17.4516 13.9253 17.5609 14.0093 17.6449 14.112C17.7302 14.2147 17.7922 14.3233 17.8309 14.438C17.8696 14.5513 17.8889 14.658 17.8889 14.758C17.8889 14.762 17.8889 14.766 17.8889 14.77C17.8889 14.774 17.8889 14.778 17.8889 14.782H17.4669C17.4669 14.778 17.4669 14.774 17.4669 14.77C17.4669 14.766 17.4669 14.762 17.4669 14.758C17.4669 14.6833 17.4536 14.6093 17.4269 14.536C17.4016 14.4613 17.3622 14.394 17.3089 14.334C17.2569 14.274 17.1902 14.226 17.1089 14.19C17.0289 14.154 16.9349 14.136 16.8269 14.136C16.6802 14.136 16.5449 14.1767 16.4209 14.258C16.2969 14.338 16.1969 14.4627 16.1209 14.632C16.0449 14.8 16.0069 15.016 16.0069 15.28C16.0069 15.4813 16.0276 15.6547 16.0689 15.8C16.1116 15.944 16.1696 16.062 16.2429 16.154C16.3162 16.2447 16.4009 16.312 16.4969 16.356C16.5929 16.4 16.6956 16.422 16.8049 16.422C16.9516 16.422 17.0722 16.3973 17.1669 16.348C17.2629 16.2973 17.3369 16.2347 17.3889 16.16C17.4422 16.0853 17.4762 16.0113 17.4909 15.938V15.668H16.8149V15.328H17.8809V16.75H17.6029L17.5709 16.422C17.5602 16.4447 17.5382 16.476 17.5049 16.516C17.4716 16.556 17.4236 16.5973 17.3609 16.64C17.2996 16.6827 17.2209 16.7187 17.1249 16.748C17.0302 16.7773 16.9162 16.792 16.7829 16.792Z"
      fill="white"
    />
  </svg>
);

export default ImageIcon;
